const appBarLinks = [
  {
    name: ['About', 'North American®'],
    url: 'https://www.securehorizonannuity.com/about-north-american/',
    active: false,
  },
  {
    name: ['Secure', 'Horizon'],
    url: 'https://www.securehorizonannuity.com/secure-horizon/',
    active: false,
  },
  {
    name: ['Secure', 'Horizon Plus'],
    url: 'https://www.securehorizonannuity.com/secure-horizon-plus/',
    active: false,
  },
  {
    name: ['Secure Horizon', 'Accelerator'],
    url: 'https://www.securehorizonannuity.com/secure-horizon-accelerator/',
    active: false,
  },
  {
    name: ['Index & Strategy', 'Options'],
    url: 'https://www.securehorizonannuity.com/index-options/',
    subLinks: [
      {
        name: ['Index Options'],
        url: 'https://www.securehorizonannuity.com/index-options/',
      },
      {
        name: ['Strategy Options'],
        url: 'https://www.securehorizonannuity.com/strategy-options/',
      },
      {
        name: ['Loomis Sayles', 'Managed Futures 2 Index'],
        url: 'https://www.securehorizonannuity.com/loomis-sayles-managed-futures-2-index/',
      },
      {
        name: ['NYSE® GEARS Index'],
        url: 'https://www.securehorizonannuity.com/nyse-gears-index/',
      },
      {
        name: ['Research Affiliates®', 'Global Multi-Asset Index'],
        url: 'https://www.securehorizonannuity.com/research-affiliates-global-multi-asset-index/',
      },
      {
        name: ['S&P 500® Index'],
        url: 'https://www.securehorizonannuity.com/sp-500-index/',
      }, {
        name: ['S&P 500®', 'Distance Stabilizer Index'],
        url: 'https://www.securehorizonannuity.com/sp-500-distance-stabilizer-index/',
      },
      {
        name: ['S&P PRISM® Index'],
        url: ' https://www.securehorizonannuity.com/sp-prism-index/',
      },
    ],
    active: false,
  },
  {
    name: ['Social Security', 'Reduction', 'Estimator'],
    url: '',
    active: true,
  },
];

const LOGO_URL = 'https://www.securehorizonannuity.com/';

const ESTIMATED_BENEFITS = {
  POTENTIAL: 'Potential Reduction',
  MONTHLY: 'Monthly Reduction',
  LIFETIME: 'Lifetime Reduction',
};

const FILING_STATUS = {
  SINGLE: 'single',
  JOINT: 'joint',
};

const WIZARD_QUESTIONS = {
  AGES: {
    SINGLE: 'What is your age?',
    JOINT: 'What are your ages?',
  },
  MONTHLYSSBENEFITS: {
    SINGLE: 'What is your monthly Social Security benefit?',
    JOINT: 'What are your monthly Social Security benefits?',
  },
  STARTAGE: {
    SINGLE: 'What is your Social Security start age?',
    JOINT: 'What are your Social Security start ages?',
  },
  SSBENEFITSTARTAGE: {
    SINGLE:
      'The age you started or will start receiving Social Security benefits.',
    JOINT:
      'The age you and your spouse started or will start receiving Social Security benefits.',
  },
};

const WIZARD_MAXMIN = {};
const CURRENT_AGE = {
  MAX: 79,
  MIN: 40,
};
const SPOUSE_CURRENT_AGE = {
  MAX: 79,
  MIN: 40,
};
const SOCIAL_SECURITY_START_AGE = {
  MAX: 70,
  MIN: 62,
};
const SPOUSE_SOCIAL_SECURITY_START_AGE = {
  MAX: 70,
  MIN: 62,
};
const INITIAL_SOCIAL_SECURITY_BENEFIT = {
  MAX: 11500,
  MIN: 1,
};
const SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT = {
  MAX: 11500,
  MIN: 1,
};
const POTENTIAL_REDUCTION_ESTIMATED = {
  MAX: 22,
  MIN: 1,
};

const DOWNLOAD_BROCHURE_URL = 'https://nash21.s3.amazonaws.com/34529Z-PlanGap-Benefit-Brochure.pdf';
const LEARN_MORE_SECURE_HORIZON_URL = 'https://www.securehorizonannuity.com/secure-horizon-plus';

export {
  ESTIMATED_BENEFITS,
  appBarLinks,
  FILING_STATUS,
  WIZARD_QUESTIONS,
  WIZARD_MAXMIN,
  CURRENT_AGE,
  SPOUSE_CURRENT_AGE,
  SOCIAL_SECURITY_START_AGE,
  SPOUSE_SOCIAL_SECURITY_START_AGE,
  INITIAL_SOCIAL_SECURITY_BENEFIT,
  SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT,
  POTENTIAL_REDUCTION_ESTIMATED,
  DOWNLOAD_BROCHURE_URL,
  LEARN_MORE_SECURE_HORIZON_URL,
  LOGO_URL,
};
